import { Typography } from "@mui/material";
import { ReactNode } from "react";

/**
 * What a settlement panel shows instead of its chart or figures when the
 * current view has nothing to plot. The panel itself stays, with its label and
 * what it says of itself, so the section still exists for the nav and the
 * reader learns why it is empty rather than seeing a blank area.
 */
export const EmptyPanelNote = ({ children }: { children: ReactNode }) => (
  <Typography
    variant="body2"
    sx={{
      color: "text.secondary",
      textAlign: "center",
      fontStyle: "italic",
      textWrap: "pretty",
      py: 3,
    }}
  >
    {children}
  </Typography>
);
